import { render, staticRenderFns } from "./TaskStatusList.vue?vue&type=template&id=336c9425&scoped=true&"
import script from "./TaskStatusList.vue?vue&type=script&lang=js&"
export * from "./TaskStatusList.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusList.vue?vue&type=style&index=0&id=336c9425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336c9425",
  null
  
)

export default component.exports